// Full-document render of the expired-login-token view: PageSkeleton (the
// React document shell) wrapping the shared UtilityExpiredTokenBody (the
// legacy utility container, not the account side-nav body).
import React from "react";
import { UtilityExpiredTokenBody } from "tsi-common-react/src/apps/customer-account/UtilityExpiredTokenBody/index";

import { templates } from "@reactivated";

import { PageSkeleton } from "../components/PageSkeleton";

export const Template = (
    props: templates.ExpiredTokenDocumentTemplate,
): React.JSX.Element => {
    return (
        <PageSkeleton pageChrome={props.page_chrome}>
            <UtilityExpiredTokenBody {...props} />
        </PageSkeleton>
    );
};
